import { Form, Formik, FormikHelpers } from "formik";
import { useState } from "react";
import { TestQuestionFormValues } from "src/models/TestQuestion.model";
import { useAddTestQuestionMutation } from "src/services/TestQuestionServices";
import { showToast } from "src/utils/showToaster";
import { array, boolean, object, string } from "yup";
import TestQuestionForm from "../Layout/TestQuestionForm";
import { useNavigate } from "react-router-dom";

const AddTestQuestionFormWrapper = () => {
  const navigate = useNavigate();
  const [saveNextChecked, setSaveNextChecked] = useState(true);

  const [addTestQuestion] = useAddTestQuestionMutation();

  // Form Initial Values
  const initialValues: TestQuestionFormValues = {
    questionType: "",
    problemAnswerType: false,
    questionCategoryId: [],
    questionTag: [],
    questionTechnologyId: [],
    questionTitle: "",
    questionDescription: "",
    questionOptions: [
      {
        optionName: "",
        isCorrect: false,
      },
      {
        optionName: "",
        isCorrect: false,
      },
    ],
    answer: "",
  };

  // Validation Schema

  const validationSchema = object().shape({
    questionType: object().required("Question type is required"),
    // problemAnswerType: object().test(
    //   'is-required-when-mcq',
    //   'Answer type is required for MCQ questions',
    //   function (value) {
    //     const { questionType } = this.parent;
    //     if (questionType?.value === 'MCQ') {
    //       return value !== undefined && value !== null;
    //     }
    //     return true;
    //   }
    // ),
    questionCategoryId: array().min(1, "At least one category is required"),
    questionTag: array().min(1, "At least one tag is required"),
    questionTechnologyId: array().min(1, "At least one technology is required"),
    questionTitle: string().required("Question title is required"),
    questionDescription: string().required("Question description is required"),
    // answer: string().required("Answer is required"),
    questionOptions: array().of(
      object().shape({
        optionName: string().test(
          "isRequiredForMCQ",
          "Option name is required",
          function (value) {
            const { questionType }: any = this.options.context;
            if (questionType?.value === "MCQ") {
              return !!value;
            }
            return true;
          }
        ),
        isCorrect: boolean().required("isCorrect is required").test(
          "atLeastOneCorrect",
          "At least one choose correct answer",
          function (options: any) {
            const { questionType, questionOptions }: any = this.options.context;
            if (questionType?.value === "MCQ") {
              let isCheck = questionOptions?.some((option: any) => option.isCorrect)
              return isCheck;
            }
            return true;
          }
        ),

      })
    ),
  });

  // Handle Submit
  const handleSubmit = (
    values: TestQuestionFormValues,
    { setSubmitting, resetForm }: FormikHelpers<TestQuestionFormValues>
  ) => {
    const formatedValue = {
      questionType: values?.questionType?.value,
      problemAnswerType:
        values?.questionType?.value === "MCQ"
          ? values?.problemAnswerType
            ? "MULTIPLE"
            : "SINGLE"
          : "",
      questionCategoryId: values?.questionCategoryId?.map(
        (category: any) => category?.value
      ),
      questionTag: values?.questionTag,
      questionTechnologyId: values?.questionTechnologyId?.map(
        (technology: any) => technology?.value
      ),
      questionTitle: values?.questionTitle,
      description: values?.questionDescription,
      questionOption: values?.questionOptions,
      answer: values?.answer,
    };
    addTestQuestion(formatedValue).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm({
            values: {
              // Set initial values for the fields you want to reset
              questionType: "",
              problemAnswerType: false,
              questionCategoryId: values?.questionCategoryId?.map(
                (category: any) => ({
                  label: category?.label,
                  value: category?.value,
                })
              ),
              questionTag: values?.questionTag,
              questionTechnologyId: values?.questionTechnologyId?.map(
                (technology: any) => ({
                  label: technology?.label,
                  value: technology?.value,
                })
              ),
              questionTitle: "",
              questionDescription: "",
              questionOptions: [
                {
                  optionName: "",
                  isCorrect: false,
                },
              ],
              answer: "",
            },
          });
          if (!saveNextChecked) {
            navigate("/test-module/questions");
            resetForm();
          }
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form className="h-full overflow-hidden contents">
          <TestQuestionForm
            formikProps={formikProps}
            formType="Add"
            setSaveNextChecked={setSaveNextChecked}
            saveNextChecked={saveNextChecked}
          />
        </Form>
      )}
    </Formik>
  );
};

export default AddTestQuestionFormWrapper;
